var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0806 5.86694L11.0806 11.8669L5.08057 11.8669C4.81535 11.8669 4.561 11.9723 4.37346 12.1598C4.18592 12.3474 4.08057 12.6017 4.08057 12.8669C4.08057 13.1322 4.18592 13.3865 4.37346 13.574C4.561 13.7616 4.81535 13.8669 5.08057 13.8669L11.0806 13.8669L11.0806 19.8669C11.0806 20.1322 11.1859 20.3865 11.3735 20.574C11.561 20.7616 11.8154 20.8669 12.0806 20.8669C12.3458 20.8669 12.6001 20.7616 12.7877 20.574C12.9752 20.3865 13.0806 20.1322 13.0806 19.8669L13.0806 13.8669L19.0806 13.8669C19.3458 13.8669 19.6001 13.7616 19.7877 13.574C19.9752 13.3865 20.0806 13.1322 20.0806 12.8669C20.0806 12.6017 19.9752 12.3474 19.7877 12.1598C19.6001 11.9723 19.3458 11.8669 19.0806 11.8669L13.0806 11.8669L13.0806 5.86694C13.0806 5.60172 12.9752 5.34737 12.7877 5.15983C12.6001 4.9723 12.3458 4.86694 12.0806 4.86694C11.8153 4.86694 11.561 4.9723 11.3735 5.15983C11.1859 5.34737 11.0806 5.60172 11.0806 5.86694Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.72df3559ed20a8030808cf8d7aac2b45.svg";
export { ForwardRef as ReactComponent };